/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var trigger_on_changes = document.querySelectorAll('.js-submit-change');
  if(trigger_on_changes) {
    trigger_on_changes.forEach((trigger_on_change) => {
      trigger_on_change.addEventListener('change', () => {
        trigger_on_change.submit();
      });
    });
  }

  var trigger_category_changes = document.querySelectorAll('.js-category');
  if(trigger_category_changes) {
    trigger_category_changes.forEach((trigger_category_change) => {
      trigger_category_change.addEventListener('change', (e) => {
        e.preventDefault();

        var category_base = trigger_category_change.getAttribute('data-category-base');

        if(category_base === '') {
          category_base = 'category';
        }

        if(trigger_category_change.querySelector('select').value === '0') {
          location.href = trigger_category_change.getAttribute('data-url-prefix');

          return;
        }

        location.href = trigger_category_change.getAttribute('data-url-prefix') + '/' + category_base + '/' + trigger_category_change.querySelector('select').value;
      });
    });
  }
}());